import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api } from "../lib/api";
import { Reveal, useSeo } from "../lib/ui";

export default function RankingAlertStop() {
  const { token } = useParams();
  const [state, setState] = useState("working");

  useSeo({ title: "Ranking alerts stopped", description: "Unsubscribe from Kenya FIFA ranking alerts." });

  useEffect(() => {
    api.post(`/ranking-alerts/stop/${token}`)
      .then(() => setState("done"))
      .catch(() => setState("failed"));
  }, [token]);

  const copy = {
    working: ["Stopping your alerts", "One moment."],
    done: [
      "Your ranking alerts are stopped",
      "You will not be emailed about the FIFA ranking again. Your address is not used for anything else, and you can sign up again whenever you like.",
    ],
    failed: [
      "We could not find that link",
      "The link may already have been used. If you are still getting alerts, reply to any one of them and we will take you off by hand.",
    ],
  }[state];

  return (
    <div className="bg-black pb-24 pt-16 md:pt-24" data-testid="ranking-alert-stop-page">
      <div className="mx-auto max-w-[1500px] px-5 md:px-10">
        <Reveal>
          <p className="eyebrow">Ranking alerts</p>
          <h1 className="display-1 mt-5 max-w-3xl" data-testid="ranking-alert-stop-heading">
            {copy[0]}
          </h1>
          <p className="body-copy mt-7 max-w-2xl">{copy[1]}</p>
        </Reveal>
        <div className="mt-10 flex flex-wrap gap-4">
          <Link to="/fifa-ranking" className="btn-primary" data-testid="stop-ranking-link">
            Kenya in the FIFA ranking <ArrowRight size={14} />
          </Link>
          <Link to="/" className="btn-ghost" data-testid="stop-home-link">
            Back to the front page
          </Link>
        </div>
      </div>
    </div>
  );
}
